import type { Home } from '@lmc/ts-common'
import { PageHeader, Tabs } from '@lmc/ui-kit'
import { getNominative } from 'common/utils'
import useFeatureFlags from 'hooks/useFeatureFlags'
import useHomeType from 'hooks/useHomeType'
import { useTabNavigation } from 'hooks/useTabNavigation'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { AddRotaPatternDropdown } from '../RotaBuilder/common/components'
import { RotaPatternModal } from '../RotaPattern'
import NewRotaPatternModal from '../RotaPattern/NewRotaPatternModal/NewRotaPatternModal'
import RotaShiftsTable from '../RotaPattern/RotaShiftsTable'
import RotaVisitsTable from '../RotaPattern/RotaVisitsTable'
export const RotaManageVisitsScreen = () => {
  const { hasRota } = useHomeType()

  const { t } = useTranslation()

  const flags = useFeatureFlags({
    flagNames: ['new_create_pattern']
  })?.data

  const flagsNewCreatePatternEnabled = flags?.new_create_pattern?.enabled

  const [patternModalVisible, setPatternModalVisible] = useState(false)

  const preferredPeopleNominative: string = useSelector(
    (state: { global: { home: Home } }) =>
      state.global.home.preferredPeopleNominative || ''
  )

  const { handleTabChange, tabKey } = useTabNavigation('visits')

  if (!hasRota) {
    return null
  }

  const residentsNominative = getNominative(
    preferredPeopleNominative,
    'Residents'
  )

  return (
    <Container>
      <PageHeader
        title={t('MANAGE_PATTERNS')}
        subtitle={t('CREATE_VISITS_FOR_SPECIFIC', {
          variable: residentsNominative
        })}
      >
        <AddRotaPatternDropdown />
      </PageHeader>
      {patternModalVisible &&
        (flagsNewCreatePatternEnabled ? (
          <NewRotaPatternModal
            onCancel={() => setPatternModalVisible(false)}
            type="visit"
          />
        ) : (
          <RotaPatternModal
            type="visit"
            patternModalVisible={patternModalVisible}
            onCancel={() => setPatternModalVisible(false)}
          />
        ))}
      <Tabs
        tabBarStyle={tabBarStyle}
        activeKey={tabKey}
        onChange={handleTabChange}
        items={[
          {
            key: 'visits',
            label: t('VISITS'),
            children: <RotaVisitsTable />
          },
          {
            key: 'shifts',
            label: t('SHIFTS'),
            children: <RotaShiftsTable />
          }
        ]}
      />
    </Container>
  )
}

const Container = styled.div`
  padding: 24px 48px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const tabBarStyle = { paddingLeft: 24 }
